module.exports = __webpack_public_path__ + "img/pocket-11_en.b7e37df.jpg";